import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './ProductsOverview.css';

const ProductsOverview = () => {
  const [filter, setFilter] = useState('all');

  const products = [
    {
      title: 'Custom Cardboard Boxes',
      text: 'Durable, bespoke boxes for packaging, tailored to your brand’s needs.',
      image: 'https://www.tradeprint.co.uk/dam/jcr:5e00ee31-a0e0-4327-bc7c-6e08f9fed121/Bespoke%20Boxes%20.webp',
      type: 'Packaging',
      id: 'boxes',
    },
    {
      title: 'Printed Posters',
      text: 'Vibrant, high-quality posters for promotions or displays.',
      image: 'https://abcprints.co.uk/wp-content/uploads/2021/09/Poster-print-example-mockup-510x600.png',
      type: 'Promotional',
      id: 'posters',
    },
    {
      title: 'Cardboard Packaging Inserts',
      text: 'Eco-friendly inserts to secure and protect your products.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQP27DiM4c9GYG7RMPNnVSLqWmk_2EMGK_n0A&s',
      type: 'Packaging',
      id: 'inserts',
    },
    {
      title: 'Branded Booklets',
      text: 'Custom-bound booklets for catalogs, manuals, or marketing.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmURHunwMpGm2allPEBPYPaGP9cd0_wv5iOw&s',
      type: 'Binding',
      id: 'booklets',
    },
    {
      title: 'Retail Displays',
      text: 'Eye-catching cardboard displays for in-store promotions.',
      image: 'https://images.samsung.com/is/image/samsung/assets/global/p6-b2b/pilot/ds-com/industries/retail/Retail-KV_PC.jpg?imwidth=1366',
      type: 'Promotional',
      id: 'displays',
    },
    {
      title: 'Bound Presentation Folders',
      text: 'Professional folders for documents, customized with your logo.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9nxdBeVwg456DUh62n4hjD2ebG_M2r4HZvQ&s',
      type: 'Binding',
      id: 'folders',
    },
  ];

  const categories = ['All', 'Packaging', 'Promotional', 'Binding'];

  const filteredProducts = filter === 'all' ? products : products.filter(product => product.type === filter);

  return (
    <section id="products" className="products">
      <motion.div
        className="products-header"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        <h2 className="products-heading">Our Printing Solutions</h2>
        <p className="products-subheading">
          Discover high-quality, custom cardboard printing and binding for your business.
        </p>
      </motion.div>

      <div className="products-filters">
        {categories.map(category => (
          <motion.button
            key={category}
            className={`filter-btn ${filter === category.toLowerCase() ? 'active' : ''}`}
            onClick={() => setFilter(category.toLowerCase())}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {category}
          </motion.button>
        ))}
      </div>

      <motion.div
        className="products-grid"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {filteredProducts.map(product => (
          <motion.div
            key={product.id}
            className="product-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
            viewport={{ once: true }}
            whileHover={{ y: -5, boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)' }}
          >
            <div className="product-image" style={{ backgroundImage: `url(${product.image})` }} />
            <div className="product-details">
              <h3 className="product-title">{product.title}</h3>
              <p className="product-description">{product.text}</p>
              <a href={`#${product.id}`} className="product-link">Learn More</a>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <div className="products-footer">
        <p>
          Contact NIRUPRINT SOLUTIONS for custom orders: <a href="mailto:nirupal92@gmail.com">nirupal92@gmail.com</a> |{' '}
          <a href="tel:+447304083286">07304 083286</a>
        </p>
        <p>UNIT H2C, Deseronto Estate, St. Mary Road, Slough, Berkshire, SL3 7EW</p>
      </div>
    </section>
  );
};

export default ProductsOverview;